import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButton],
})
export class ConfirmationDialogComponent {
  private readonly dialogRef = inject<MatDialogRef<ConfirmationDialogComponent>>(MatDialogRef);
  private readonly data = inject(MAT_DIALOG_DATA);
  messages: string[] = [];
  acceptButtonText: string;
  cancelButtonText: string;

  constructor() {
    this.messages = this.data.messages;
    this.acceptButtonText = this.data.acceptButtonText;
    this.cancelButtonText = this.data.cancelButtonText;
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  accept(): void {
    this.dialogRef.close(true);
  }
}
